export class oDataRes{
    value?: any[];
}